/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_AccountingInputs */

const en_role_accounting = /** @type {(inputs: Role_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounting`)
};

const es_role_accounting = /** @type {(inputs: Role_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contabilidad`)
};

/**
* | output |
* | --- |
* | "Accounting" |
*
* @param {Role_AccountingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_accounting = /** @type {((inputs?: Role_AccountingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_AccountingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_accounting(inputs)
	return es_role_accounting(inputs)
});